import { QrCodeObject } from "@/models/QrCodeObject";

export interface QrcodeState {
    qrcodeObject: QrCodeObject;
    logoB64: string;
    videoUrl: string;
    audioUrl: string;
    currentPhotos: string[];
    customHtml: string;
    customFullHtml: string;
    customJs: string[];
    error: { title: string; text: string };
    isBanned: boolean;
    webarUrl:string;
    isThankYouEmailSent: boolean;
    isThankYouEmailAllowed: boolean;
}

const defaultState: QrcodeState = {
    qrcodeObject: null,
    logoB64: "",
    videoUrl: "",
    audioUrl: "",
    currentPhotos: [],
    customHtml: "",
    customFullHtml: "",
    customJs: [],
    error: { title: "", text: "" },
    isBanned: false,
    webarUrl: "",
    isThankYouEmailSent: false,
    isThankYouEmailAllowed: false,
};

export default defaultState;
